import { render, staticRenderFns } from "./BlockBox.vue?vue&type=template&id=175a268a&scoped=true"
import script from "./BlockBox.vue?vue&type=script&lang=js"
export * from "./BlockBox.vue?vue&type=script&lang=js"
import style0 from "./BlockBox.vue?vue&type=style&index=0&id=175a268a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a268a",
  null
  
)

export default component.exports